<template>
    <div
        class="ContentReset"
        v-html="cleanedBody"
    />
</template>

<script setup lang="ts">
import { useLayoutMode, useOrganizationContext } from '#imports'
import { computed } from 'vue'

const props = defineProps<{
    body: string
}>()

const org = useOrganizationContext()
const { isMobileApp } = useLayoutMode()

const cleanedBody = computed(() => {
    if (isMobileApp.value) {
        const parser = new DOMParser()
        const document = parser.parseFromString(props.body, 'text/html')

        document
            .querySelectorAll<HTMLAnchorElement>('a[href]')
            // For every href field in an anchor element
            .forEach(anchor => {
                let href = anchor.getAttribute('href')
                if (href === null) {
                    return
                }

                let isMobileUrl = false

                // For every facility public URL
                for (const value of org.value.facilityPublicUrls) {
                    // If the href contains the public URL
                    if (href.includes(value)) {
                        // Replace the public URL with the org's mobile URL
                        href = href.replace(value, org.value.mobileUrl)
                        anchor.setAttribute('href', href)
                        isMobileUrl = true
                        // Break
                        break
                    }
                }

                // Open mobile URLs in current window, else open in new window
                if (isMobileUrl) {
                    anchor.setAttribute('target', '')
                } else {
                    anchor.setAttribute('target', '_blank')
                }
            })

        return document.body.innerHTML
    } else {
        // Regex for `<a` which is NOT followed by 0 or more non `>` characters and then `target="_blank"`
        const regularExpression = /<a(?![^>]*\btarget="_blank")/gi

        // Replace all matches with <a target="_blank"
        return props.body.replace(regularExpression, '<a target="_blank"')
    }
})
</script>
